import type { SubstitutionRule, UnitWithType } from "@corca/data";

export function mapUnitToSetChildren(unit: UnitWithType): SubstitutionRule["setChildren"] {
  return {
    children: [
      {
        type: "unit",
        props: {
          placement: unit.placement,
          unitType: unit.unitType,
        },
        children: [
          {
            type: "inline",
            children: unit.children,
          },
        ],
      },
    ],
    skipChildNodes: {
      hasType: ["operator:power", "operator:subscript", "symbol", "inline"],
    },
  };
}
